/*
 * @Author: Json Chen
 * @Date: 2021-07-08 10:00:30
 * @LastEditTime: 2022-06-29 11:44:03
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/Hooks/useBreadCrumbData.ts
 */
import { useSalesChannel } from '@/src/constrains/SalesChannelHOC/useSalesChannel';
import { useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

interface Bread {
  url: string;
  name: string;
}

const useBreadCrumbData = ({
  lastSecond,
  lastOne,
  defaultBread,
}: {
  lastSecond: string;
  lastOne: string;
  defaultBread?: Bread[];
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { loading, name } = useSalesChannel();
  const { uuid } = useParams() as any;
  return {
    loading: loading,
    breadcrumbData: (
      defaultBread || [
        {
          url: '',
          name: getI18n('general.home'),
        },
        {
          url: '/salesChannels',
          name: getI18n('general.sider.salesChannel'),
        },
      ]
    ).concat([
      {
        url: `/salesChannel/content/${uuid}`,
        name: name,
      },
      {
        url: `/salesChannel/settings/${uuid}`,
        name: lastSecond,
      },
      {
        url: ``,
        name: `${lastOne}`,
      },
    ]),
  };
};

export default useBreadCrumbData;
